<template>
  <div>
    <material-button
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modalDeliverySlots"
      id="show-modal-delivery-slots"
    ></material-button>
    <div class="modal fade" id="modalDeliverySlots" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Delivery Slots</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div v-if="loading" class="text-center py-3">Loading...</div>
            <div v-else class="table-responsive">
              <table class="table align-middle delivery-slot-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Cut-off Time</th>
                    <th>Delivery Time</th>
                    <th>Display</th>
                    <th>Quota Orders</th>
                    <th>Quota Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(slot, index) in slots" :key="index">
                    <td>
                      <i
                        class="material-icons text-danger cursor-pointer"
                        title="Delete slot"
                        @click="removeSlot(index)"
                        >delete</i
                      >
                    </td>
                    <td><input type="time" class="form-control" v-model="slot.cutoff_time" /></td>
                    <td><input type="time" class="form-control" v-model="slot.delivery_time" /></td>
                    <td><input type="text" class="form-control" maxlength="50" v-model="slot.display" /></td>
                    <td><input type="number" min="0" class="form-control" v-model="slot.quota_orders" /></td>
                    <td><input type="number" min="0" class="form-control" v-model="slot.quota_quantity" /></td>
                  </tr>
                </tbody>
              </table>
              <div class="fs-14">Quota 0 = unlimited. A slot disappears from MOO once its cut-off has passed or its quota is full.</div>
            </div>
            <div v-if="error" class="text-danger fs-14 mt-2">{{ error }}</div>
          </div>
          <div class="modal-footer justify-content-between">
            <material-button class="btn btn-sm btn-background" :disabled="loading" @click="addSlot">Add Slot</material-button>
            <material-button class="btn btn-sm btn-background" :disabled="loading || saving" @click="save">Save</material-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import SettingStoreService from "../services/settingStore.service";

// M986 follow-up: a sale channel's MOO Delivery slots, copied from iMakan's
// "Default Pickup/Delivery Slots". Saving replaces the whole list.
export default {
  name: "ModalDeliverySlots",
  components: { MaterialButton },
  props: {
    branchId: { type: [Number, String], default: 0 },
  },
  emits: ["saved"],
  data() {
    return { slots: [], loading: false, saving: false, error: "" };
  },
  methods: {
    open() {
      this.error = "";
      this.loading = true;
      document.getElementById("show-modal-delivery-slots").click();
      SettingStoreService.getDeliverySlots(this.branchId).then(
        (response) => {
          this.loading = false;
          if (response.data.result.isSuccess) {
            this.slots = response.data.data.slots.map((slot) => ({ ...slot }));
          } else {
            this.error = response.data.result.message;
          }
        },
        (error) => {
          this.loading = false;
          this.error = error.message;
        }
      );
    },
    addSlot() {
      const last = this.slots[this.slots.length - 1];
      const start = last ? this.addMinutes(last.delivery_time, 30) : "10:00";
      this.slots.push({
        delivery_time: start,
        cutoff_time: this.addMinutes(start, -30),
        display: start + "-" + this.addMinutes(start, 30),
        quota_orders: 0,
        quota_quantity: 0,
      });
    },
    removeSlot(index) {
      this.slots.splice(index, 1);
    },
    addMinutes(time, minutes) {
      const [h, m] = String(time || "00:00").split(":").map(Number);
      const total = Math.min(Math.max(h * 60 + m + minutes, 0), 23 * 60 + 59);
      return String(Math.floor(total / 60)).padStart(2, "0") + ":" + String(total % 60).padStart(2, "0");
    },
    save() {
      this.error = "";
      this.saving = true;
      SettingStoreService.saveDeliverySlots({ branch_id: this.branchId, slots: this.slots }).then(
        (response) => {
          this.saving = false;
          if (response.data.result.isSuccess) {
            this.slots = response.data.data.slots.map((slot) => ({ ...slot }));
            document.querySelector("#modalDeliverySlots .btn-close-modal").click();
            this.$emit("saved");
          } else {
            this.error = response.data.result.message;
          }
        },
        (error) => {
          this.saving = false;
          this.error = error.message;
        }
      );
    },
  },
};
</script>

<style scoped>
.delivery-slot-table th {
  font-size: 13px;
  white-space: nowrap;
}
.delivery-slot-table input {
  min-width: 90px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
